import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getOption',
})
export class GetOptionPipe implements PipeTransform {

  transform(id: any, list: any): any {
    if (id !== null && id !== undefined) {
      return list.find(x => x.id === id)?.statusOption;
    }
    return null;
  }

}
